module.exports = "/_next/static/images/studying-6fb61e35e0c96d9143b8fad1e5e74d04.svg";